"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnterpriseStrings = void 0;
exports.EnterpriseStrings = {
    listTitle: "Enterprises",
};
//# sourceMappingURL=enterprise.js.map